const {client, loadToken} = require('./client');
export { loadToken };


export async function getAllGroups(){
  var {data} = await client.get(`/groups`);
  return data;
}

export async function getGroupWithID(id){
  var {data} = await client.get(`/groups/${id}`);
  return data;
}

export async function saveGroupWithID(id, data){
  var {data} = await client.put(`/groups/${id}`, data);
  return data;
}

export async function getGroupWithDeviceUUID(uuid){
  var {data} = await client.get(`/groups/device/${uuid}`);
  return data;
}

export async function getGroupDeviceUUIDSWithIDs(ids){
  var {data} = await client.get(`/groups/getAllUUIDs/${ids.join(',')}`);
  return data;
}

const all = {
  loadToken, getAllGroups, getGroupWithID, saveGroupWithID, getGroupWithDeviceUUID, getGroupDeviceUUIDSWithIDs
};

export default all;